import { computed, Injectable, signal, Signal, WritableSignal } from '@angular/core';
import { IIqCarrierResourcesStateService } from '../../models';
import { Client, Config, createInstance } from '@optimizely/optimizely-sdk';


// We need to localize the optimizely client instance to avoid multiple instances. This is a temporary solution until we get Krishna's PR in.
const optimizelyClientInstance = createInstance({
    sdkKey: '5jYRyMHfn5dtZPyVV3Snp',
});


@Injectable({
    providedIn: 'root',
})
export class IqCarrierResourcesStateService
    implements IIqCarrierResourcesStateService
{
    constructor() {
    }

    spotBlurb(): Signal<string> {
        const blurb: WritableSignal<string> = signal('--');

        optimizelyClientInstance.onReady().then((x) => {
            const user = optimizelyClientInstance.createUserContext(
                'user_id',
                {},
            );
            const decision = user.decide('iq_com_trendline_weekly_brief');
            const blurbVariation: string = decision.variables['spot_blurb'] as string;
            blurb.set(blurbVariation);
        });

        return computed(() => blurb());
    }
    
}
